import React, { createContext, useContext, useState } from 'react';

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
    const [isNotificationOpen, setIsNotificationOpen] = useState(false);
    const [shouldRefresh, setShouldRefresh] = useState(false);

    const openNotifications = () => {
        setIsNotificationOpen(true);
        setShouldRefresh(true);
    };

    const closeNotifications = () => {
        setIsNotificationOpen(false);
    };

    const resetRefresh = () => {
        setShouldRefresh(false);
    };

    return (
        <NotificationContext.Provider value={{
            isNotificationOpen,
            shouldRefresh,
            openNotifications,
            closeNotifications,
            resetRefresh
        }}>
            {children}
        </NotificationContext.Provider>
    );
};

export const useNotifications = () => {
    const context = useContext(NotificationContext);
    if (!context) {
        throw new Error('useNotifications must be used within a NotificationProvider');
    }
    return context;
};